import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import { takeUntil } from 'rxjs/operators';
import { selectAppSettings } from 'src/app/state/selectors/app-settings.selectors';
import { ServerConfig } from '../../../cloud-api/model/response/server-config.model';
import { ServerConfigService } from '../../../cloud-api/services/server-config.service';
import { SSOConfigService } from '../../../cloud-api/services/sso-config.service';
import { AppState } from '../../../../app.state';
import { ApiProviderService } from 'src/app/services/api-provider.service';
import { UserManagementConst } from '../../model/user-management.const.model';
import { isStringNullOrWhiteSpace } from 'src/app/util/StringUtil';
import { NavigationService } from 'src/app/modules/shared/services/navigation-service.service';
import { SsoService } from 'src/app/modules/shared/services/sso.service';

@Component({
  selector: 'aca-sso-login-panel',
  templateUrl: './sso-login-panel.component.html',
  styleUrls: ['./sso-login-panel.component.less']
})
export class SsoLoginPanelComponent implements OnInit, OnDestroy {
  adminMode: boolean;
  idpInfoLoaded: boolean = false;
  idpInfoUrl: string;
  returnURL: string;
  protected destroyActions = new Subject<boolean>();

  constructor(private serverConfigService: ServerConfigService, private apiRef: ApiProviderService, private ssoService: SsoService,
    public navigationService: NavigationService, private ssoConfigService: SSOConfigService, private store: Store<AppState>,) { }

  ngOnInit(): void {
    this.store.select(selectAppSettings)
      .pipe(takeUntil(this.destroyActions))
      .subscribe({
        next: state => {
          this.adminMode = state.AdminMode;
          if (!this.adminMode) {
            this.serverConfigService.get()
              .pipe(takeUntil(this.destroyActions))
              .subscribe(res => {
                this.getSSORedirectUrlInfo(res);
              });
          }
        }
      });

      //check for and store any ReturnUrl parameter
      const urlParams = new URLSearchParams(this.apiRef.nativeWindow.location.search);
      const rUrlParam =  urlParams.get(UserManagementConst.RETURN_URL)?.trim();
      if(!isStringNullOrWhiteSpace(rUrlParam)){
        const url = this.apiRef.nativeWindow.location.search;
        this.returnURL = decodeURIComponent(url.substring(url.indexOf(UserManagementConst.RETURN_URL)+10));
        this.ssoService.cacheRedirectUrl(this.returnURL)
          .pipe(takeUntil(this.destroyActions))
          .subscribe();
      }
    
  }

  getSSORedirectUrlInfo(configData: ServerConfig): void {
    this.ssoConfigService.getSSORedirectUrl(configData)
      .pipe(takeUntil(this.destroyActions))
      .subscribe(res => {
        if (res) {
          this.idpInfoUrl = res.redirectUrl;
          this.idpInfoLoaded = true;
        }
      });
  }

  signInBtnClick(): void {
    if (this.idpInfoUrl) {
      this.navigationService.navigate(this.idpInfoUrl);;
    }
  }

  newUserRegistration(event: MouseEvent): void {
    if (this.idpInfoUrl) {
      this.navigationService.navigate(this.idpInfoUrl);;
    }
  }

  ngOnDestroy(): void {
    this.destroyActions.next(null);
    this.destroyActions.complete();
  }
}
